<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                白色污染的严重性
            </div>
            <div class="content" v-if="index == 1">
                <div class="videoView">
                    <video src="../../assets/video/baiwuranda.mp4" controls muted="true" poster="../../assets/video/baiwuranda-poster.jpg" />
                </div>
                <div class="link-content">
                    <div class="toVideo">
                        <img src="../../assets/images/shipin.jpg" /> <a>视频介绍</a>
                    </div>
                    <div class="toText">
                        <img src="../../assets/images/wenben.jpg" /> <a href="javascript:void(0)" @click="index = 2">文字版</a>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="content" v-if="index == 2">
                <div class="paragraph">
                    <div>
                        <p class="indent">伴随人们生活节奏的加快，社会生活正向便利化、卫生化发展。为了顺应这种需求，一次性泡沫塑料饭盒、塑料袋、筷子、水杯等开始频繁地进入人们的日常生活。这些使用方便、价格低廉的包装材料的出现给人们的生活带来了诸多便利。但另一方面，这些包装材料在使用后往往被随手丢弃，造成"白色污染";形成环境危害，成为极大的环境问题。</p>
                        <p class="indent">所谓"白色污染"是指由农用薄膜、包装用塑料膜、塑料袋和一次性塑料餐具（以下统称塑料包装物）的丢弃所造成的环境污染。由于废旧塑料包装物大多呈白色，因此称之为"白色污染"。我国是世界上十大塑料制品生产和消费国之一，所以“白色污染”日益严重。 1995年全国塑料消费总量约1100万吨，其中包装用塑料达211万吨。包装用塑料的大部分以废旧薄膜、塑料袋和泡沫塑料餐具的形式被任意丢弃。据调查，北京市生活垃圾的3%为废旧塑料包装物，每年产生量约为14万吨；上海市生活垃圾的7%为废旧塑料包装物，每年产生量约为19万吨。丢弃在环境中的废旧包装塑料，不仅影响市容和自然景观，产生"视觉污染"，而且因难以降解，对生态环境还会造成潜在危害，如：混在土壤中，影响农作物吸收养分和水分，导致农作物减产；增塑剂和添加剂的渗出会导致地下水污染；混入城市垃圾一同焚烧会产生有害气体，污染空气，损害人体健康；填埋处理将会长期占用土地，等等。我国每年用于白色污染的治理经费大约1850万左右。</p>
                        <p class="bold">塑料垃圾的危害</p>
                        <p class="indent">目前，一些国家视降解塑料为继金属材料、无机材料和高分子材料之后的第四种重要应用材料，且已成为各工业发达国家争相研制和开发的重点。尤其近年来，国际上生物降解塑料的发展较为迅速。其产品已广泛应用于包装领域。但目前，世界上还没有一家企业能够提供一种有效耐用可被市场接受的降解塑料。世界上仅有美国、英国、意大利和日本能生产完全降解塑料，以垄断数十亿美元的国际市场。全生物降解塑料在国际产品方面已有四大品牌：美国的NOVON、意大利的Mater-Bi、英国的BLOPODT和日本的BLONLE，真正形成工业化生产的只有意大利的Mater-Bi。产品仍有不足之处，且产品的价格高达7000多美元／吨，很难大规模推广应用。</p>
                        <p class="indent">我国于2008年6月1日起实施“限塑令”，禁止使用超薄塑料袋，禁止免费提供塑料袋。</p>
                        <p class="indent red">全国每天用掉30亿个塑料袋，每年废弃量超过300吨，而降解则需100~200年。</p>
                    </div>
                </div>
                <div class="link-content">
                    <div class="bottom">
                        <img src="../../assets/images/shipin.jpg" /> <a href="javascript:void(0)" @click="index = 1">视频介绍</a>
                        <span class="margin-left">页码: </span> <span class="page active">1</span>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "WhatIsGreenhouseIndexView",
        data() {
            return {
                index: 1
            }
        },
        methods: {
            onIndexChanged(retIndex) {
                this.index = retIndex
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
                .videoView {
                    video {
                        width: 80%;
                        margin-left: 10%;
                    }
                    width: 100%;
                }
                .link-content {
                    margin-top: 10%;
                    margin-left: 10%;
                    width: 80%;
                    img {
                        width: 50px;
                        height: 50px;
                    }
                    .toVideo {
                        float: left;
                    }
                    .toText {
                        float: right;
                    }
                    a {
                        font-size: 15px;
                        color: #008000;
                        text-decoration: none;
                    }
                }
            }
            p {
                line-height: 12px;
            }
            .link-content {
                margin-top: 2%;
                margin-left: 10%;
                width: 80%;
                .bottom {
                    float: left;
                    width: 100%;
                    height: 80px;
                    img {
                        width: 50px;
                        height: 50px;
                    }
                    .paragraph {
                        .red {
                            color: #ff0000;
                        }
                        .margin-top {
                            margin-top: 20px;
                        }
                    }
                    .margin-left {
                        margin-left: 40%;
                    }
                    a, span {
                        font-size: 15px;
                        color: #008000;
                        text-decoration: none;
                        cursor: pointer;
                    }
                    .page {
                        padding: 3px 8px;
                        border: 1px #aaa solid;
                        background: #eee;
                        box-shadow: -1px -1px 2px #ccc inset;
                        font-weight: bold;
                        &.active {
                            background: #4a97d4;
                            border: 1px #175187 solid;
                            color: #fff;
                            box-shadow: -1px -1px 2px #7894bd inset;
                        }
                    }
                }

            }

        }
    }
</style>